import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XtrasService } from '../../../services/xtras.service';
import { FormsModule } from '@angular/forms';
import { RouterLink } from "@angular/router";
import { SafeHtmlPipe } from '../../../pipes/safe-html.pipe';

@Component({
  selector: 'modal-information',
  templateUrl: './information.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    SafeHtmlPipe,
  ],
})
export class InformationModal implements OnInit {

  loading: boolean = false;

  data?: any;

  get url(): string|undefined {
    if(this.data?.redirect_url) return this.data?.redirect_url;
    if(this.xServices.isAppIos() && this.data?.redirect_ios) {
      return this.data?.redirect_ios;
    } else if(this.xServices.isAppAndroid() && this.data?.redirect_android) {
      return this.data?.redirect_android;
    } else if(this.data?.redirect_web) {
      return this.data?.redirect_web;
    } else {
      return undefined;
    }
  }

  constructor(
    public xServices: XtrasService,
  ) {
  }

  dismiss(value?: any) {
    // Este método será sobrescrito por el servicio de modal
  }

  ngOnInit(): void {
  }

  cancel() {
    this.dismiss({ action: 'remove' });
  }
}

